import type { GetTrashAssetsQuery } from '../gql/generated/GetTrashAssets';

export const getTrashAssets = (data?: GetTrashAssetsQuery) => {
  return data?.account?.project?.trashAssets;
};
